// PLUGINS IMPORTS //
import React from 'react'
import { BrowserRouter, Route, Switch } from 'react-router-dom'

// COMPONENTS IMPORTS //
import Navbar from 'Content/Shared/Layout/Navbar/Navbar'

import HomeScreen from 'Content/Screens/GeneralScreens/HomeScreen/HomeScreen'
import PortfolioScreen from 'Content/Screens/GeneralScreens/PortfolioScreens/PortfolioScreen/PortfolioScreen'
import ProjectScreen from 'Content/Screens/GeneralScreens/PortfolioScreens/ProjectScreen/ProjectScreen'
import AboutScreen from 'Content/Screens/GeneralScreens/AboutScreen/AboutScreen'
import ContactsScreen from 'Content/Screens/GeneralScreens/ContactsScreen/ContactsScreen'
import BlogListScreen from 'Content/Screens/GeneralScreens/BlogScreens/BlogListScreen'
import BlogPostScreen from 'Content/Screens/GeneralScreens/BlogScreens/BlogPostScreen'

import UnknownScreen from './Content/Screens/HelperScreens/UnknownScreen/UnknownScreen'

import ScrollToTop from 'Content/Shared/Helpers/Functions/ScrollToTop'
import { memoComparison } from 'Content/Shared/Helpers/Functions/Functions'

// EXTRA IMPORTS //
import 'Content/Shared/Styles/style.css'

/////////////////////////////////////////////////////////////////////////////

type PropsType = {}

const App: React.FC<PropsType> = () => {
  return (
    <BrowserRouter basename={'artem.uno'}>
      <Navbar />

      <ScrollToTop>
        <Switch>
          <Route exact path='/' render={() => <HomeScreen />} />
          <Route exact path='/blog' render={() => <BlogListScreen />} />
          <Route exact path='/blog/:ID' render={() => <BlogPostScreen />} />

          <Route path='/portfolio' render={() => <PortfolioScreen />} />
          <Route path='/contacts' render={() => <ContactsScreen />} />
          <Route path='/me' render={() => <AboutScreen />} />

          <Route
            path='/project/:ID'
            render={(routeProps) => <ProjectScreen routeProps={routeProps} />}
          />
          <Route component={UnknownScreen} />
        </Switch>
      </ScrollToTop>
    </BrowserRouter>
  )
}

export default React.memo(App, memoComparison)
